module.exports = __webpack_public_path__ + "img/wx_code.76ffafde.png";